import React from 'react';
import { useQuery } from '@apollo/client';
import { listConformites } from '../graphql/queries';
import ConformiteDetail from '../components/admin/conformite/ConformiteDetail';
import { Message, Header } from 'semantic-ui-react';
import DisplayLoading from '../components/common/DisplayLoading';
import DisplayError from '../components/common/DisplayError';

const AdmimConformiteEditPage = () => {
  const { data, loading, error } = useQuery(listConformites, {
   fetchPolicy: 'network-only'
  });

  return (
    <>
      <DisplayLoading loadingMessage={loading} iconName="circle notched" />
      <DisplayError errorMessage={error} />
      <Message>
        <Header as="h2" color="blue">
          Liste des conformités
        </Header>
      </Message>

      <ConformiteDetail data={data} />
    </>
  );
};

export default AdmimConformiteEditPage;
